import "./App.css";
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./../node_modules/bootstrap/dist/js/bootstrap.min.js";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LandingPage from "./pages/LandingPage/LandingPage";
import NewsPage from "./pages/NewsPage/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage/NewsDetailPage.js";
import ScrollToTop from "./hooks/ScrollToTop.js";
import EventPage from "./pages/EventPage/EventPage.js";
import EventDetailPage from "./pages/EventDetailPage/EventDetailPage.js";
import DefaultPage from "./pages/DefaultPage/DefaultPage.js";

import Test from "./components/Test";
import EducationProgramPage from "./pages/EducationProgramPage/EducationProgramPage.js";
import ContactPage from "./pages/ContactPage/ContactPage.js";
import MandatoryPage from "./pages/MandatoryPage/MandatoryPage.js";
import EmployeePage from "./pages/EmployeePage/EmployeePage.js";
import GalleryPage from "./pages/GalleryPage/GalleryPage.js";
import GallerySubPage from "./pages/GallerySubPage/GallerySubPage.js";
import DocumentsPage from "./pages/DocumentsPage/DocumentsPage.js";
import PersonalDataPage from "./pages/PersonalDataPage/PersonalDataPage.js";
import SchoolCounselingPage from "./pages/SchoolCounselingPage/SchoolCounselingPage.js";
import SponsorsPage from "./pages/SponsorsPage/SponsorsPage.js";
import SchoolFacilityPage from "./pages/SchoolFacilityPage/SchoolFacilityPage.js";
import HistoryPage from "./pages/HistoryPage/HistoryPage.js";
import AuthProvider from "./components/AuthProvider/AuthProvider.jsx";
import ClassesPage from "./pages/ClassesPage/ClassesPage.js";
import ClassesDetailPage from "./pages/ClassesDetailPage/ClassesDetailPage.js";
import SchoolYearSchedule from "./pages/SchoolYearSchedulePage/SchoolYearSchedule.js";

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<LandingPage />} />
          <Route path="/aktuality" element={<NewsPage />} />
          <Route path="/aktuality/detail/:id" element={<NewsDetailPage />} />
          <Route path="/projekty" element={<EventPage />} />
          <Route path="/projekty/detail/:id" element={<EventDetailPage />} />
          <Route
            path="/organizace-skolniho-roku"
            element={<SchoolYearSchedule />}
          />
          <Route
            path="/zakladni-skola"
            element={<EducationProgramPage education="primary-school-page" />}
          />
          <Route
            path="/stredni-skola"
            element={<EducationProgramPage education="high-school-page" />}
          />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/historie" element={<HistoryPage />} />
          <Route
            path="/povinne-zverejnovane-informace"
            element={<MandatoryPage />}
          />
          <Route path="/zamestnanci" element={<EmployeePage />} />
          <Route path="/fotogalerie" element={<GalleryPage />} />
          <Route path="/fotogalerie/:id" element={<GallerySubPage />} />
          <Route path="/dokumenty" element={<DocumentsPage />} />
          <Route
            path="/ochrana-osobnich-udaju"
            element={<PersonalDataPage />}
          />
          <Route
            path="/skolni-poradenske-pracoviste"
            element={<SchoolCounselingPage />}
          />
          <Route path="/partneri" element={<SponsorsPage />} />
          <Route
            path="/jidelna"
            element={<SchoolFacilityPage facility="canteen-page" />}
          />
          <Route
            path="/skolni-druzina"
            element={<SchoolFacilityPage facility="after-school-club-page" />}
          />
          <Route path="/tridy" element={<ClassesPage />} />
          <Route path="/tridy/detail/:id" element={<ClassesDetailPage />} />
          <Route path="/test" element={<Test />} />
          <Route path="*" element={<DefaultPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
